import { useProductStore } from '@frontend/libs/stores/useProductStore'
import { Modal, ModalBody, ModalContent } from '@nextui-org/react'
import { useMemo } from 'react'

import ProductSummary from '../../product-details/ProductSummary'
import ProductGallery from '../ProductGallery'
import QuickViewLoader from './QuickViewLoader'

export function QuickView() {
  const {
    clearSelectedOption,
    closeQuickView,
    isQuickViewOpen,
    loading,
    product,
    selectedOption,
    setSelectedOption,
    variation,
  } = useProductStore((state) => state)

  const galleryImages = useMemo(() => {
    let gallery = product?.gallery

    if (variation) {
      gallery = [
        variation.image,
        ...(Array.isArray(variation.gallery) ? variation.gallery : []),
      ]
    }

    return gallery
  }, [product, variation])

  return (
    <Modal
      classNames={{
        base: 'w-full max-w-screen-lg',
        body: 'p-0',
        closeButton: 'rounded-none top-4 right-4 text-2xl z-20',
      }}
      isOpen={isQuickViewOpen}
      onOpenChange={closeQuickView}
      placement="center"
    >
      <ModalContent>
        <ModalBody>
          {loading ? (
            <QuickViewLoader />
          ) : (
            product && (
              <div className="grid grid-cols-2">
                <ProductGallery images={galleryImages} />
                <div className="p-10">
                  <ProductSummary
                    onClearSelection={clearSelectedOption}
                    onSelectOption={setSelectedOption}
                    product={product}
                    selectedOption={selectedOption}
                    variation={variation}
                  />
                </div>
              </div>
            )
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default QuickView
